import { NgModule } from "@angular/core";
import { VEX_CONFIG, VEX_THEMES } from "./config/config.token";
import { MATERIAL_SANITY_CHECKS } from "@angular/material/core";
import { VexSplashScreenService } from "./services/vex-splash-screen.service";
import { VexLayoutService } from "./services/vex-layout.service";
import { vexConfigs } from "./config/vex-configs";
import { VexTheme } from "./config/vex-config.interface";
 
@NgModule({
    imports: [
 
    ],
    exports: [
     
    ],
    providers: [
        {
            provide: VEX_CONFIG,
            useValue: vexConfigs.poseidon
          },
          {
 
           
            provide: VEX_THEMES,
            useValue: [ {
                name: 'Default',
                className: 'vex-theme-default'
              },
              {
                name: 'Blue',
                className: 'vex-theme-blue'
              },
              {
                name: 'Modern Blue',
                className: VexTheme.MODERNBLUE
              },
              {
                name: 'Dark Blue',
                className:  VexTheme.DARKBLUE
              },
              {
                name: 'Steel',
                className: 'vex-theme-steel'
              },
              {
                name: 'Teal',
                className: 'vex-theme-teal'
              },
              {
                name: 'Green',
                className: 'vex-theme-green'
              },
              {
                name: 'Purple',
                className: 'vex-theme-purple'
              },
              {
                name: 'Orange',
                className: 'vex-theme-orange'
              }
            ]
          },
          {
            provide: MATERIAL_SANITY_CHECKS,
            useValue: {
              doctype: true,
              theme: false,
              version: true
            }
          },
          VexSplashScreenService,
          VexLayoutService,
    ],
    declarations: []
  })
  export class VexModule {
  }